export const getRevertOptionKey = (opt) => `${opt.type}-${opt.value}`;

const STATUS_DESCRIPTIONS = {
  'Awaiting Approval': 'Return to awaiting approval',
  Approved: 'Return to approved status',
  'Pre-Production': 'Move job back to pre-production',
  Production: 'Move job back to production',
};

export const getRevertOptionDescription = (opt) =>
  STATUS_DESCRIPTIONS[opt.label] || 'Revert to this status';

export function buildRevertStatusOptions({
  isQuotation,
  currentQS,
  currentSt,
  currentProjStatus,
  hasProject,
  isStagedOrInstalling = false,
}) {
  if (isQuotation) {
    if (currentQS === 9) {
      return [{ label: 'Awaiting Approval', value: 4, type: 'quotation' }];
    }
    if ([4, 6, 3].includes(currentQS)) {
      return [];
    }
    return [];
  }

  const options = [];

  if (currentSt === 4) {
    options.push({ label: 'Approved', value: 3, type: 'request' });

    if (hasProject && currentProjStatus === 2) {
      options.push({ label: 'Pre-Production', value: 1, type: 'project' });
    } else if (hasProject && currentProjStatus === 3) {
      options.push(
        { label: 'Production', value: 2, type: 'project' },
        { label: 'Pre-Production', value: 1, type: 'project' },
      );
    } else if (isStagedOrInstalling) {
      options.push(
        { label: 'Production', value: 2, type: 'project' },
        { label: 'Pre-Production', value: 1, type: 'project' },
      );
    }
  }

  return options;
}
